const MBI_REGEX = /^[1-9](?:(?![SLOIBZ])[A-Z])(?:(?![SLOIBZ])[A-Z0-9])\d(?:(?![SLOIBZ])[A-Z])(?:(?![SLOIBZ])[A-Z0-9])\d(?:(?![SLOIBZ])[A-Z]){2}\d{2}$/g

function isValid (mbi: string): boolean {
  return mbi !== undefined && cleanup(mbi).match(MBI_REGEX) !== null
}

function cleanup (mbi: string): string {
  return mbi?.toString().trim().replace(/[-]/g, '')
}

// eslint-disable-next-line import/no-anonymous-default-export
export {
  isValid,
  cleanup,
  MBI_REGEX
}
